import React, { useState, useEffect } from "react";

const TicketSettingsPage = () => {
  const [settings, setSettings] = useState({
    business_name: "",
    branch_name: "",
    rfc: "",
    address: "",
    phone: "",
    footer_message: "",
    ticket_width: "80",
    show_order_number: 1,
    show_cashier: 1,
    show_qr: 0,
    qr_url: ""
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setSettings({
      ...settings,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value
    });
  };

  useEffect(() => {
    const loadSettings = async () => {
      try {
        const res = await fetch("/api/get_ticket_settings.php", {
          credentials: "include"
        });

        const data = await res.json();

        if (data.success && data.data) {
          setSettings({
            ...settings,
            ...data.data
          });
        }
      } catch (err) {
        console.error(err);
      }
    };

    loadSettings();
  }, []);

  const handleSave = async () => {
    try {
      const res = await fetch("/api/save_ticket_settings.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        credentials: "include",
        body: JSON.stringify(settings)
      });

      const data = await res.json();

      if (data.success) {
        alert("Configuración guardada");
      } else {
        alert(data.message);
      }

    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div className="bg-[#F9EFD7] p-6 rounded-lg shadow max-w-xl mx-auto mt-6">
      
      <h2 className="text-xl font-bold text-[#3F1907] mb-4">
        Configuración del Ticket ☕
      </h2>

      <div className="space-y-4">

        {/* NEGOCIO */}
        <div>
          <label className="block text-sm font-bold text-[#3F1907] mb-1">
            Nombre del Negocio
          </label>
          <input
            name="business_name"
            value={settings.business_name}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-bold text-[#3F1907] mb-1">
            Sucursal
          </label>
          <input
            name="branch_name"
            value={settings.branch_name}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-bold text-[#3F1907] mb-1">
            RFC
          </label>
          <input
            name="rfc"
            value={settings.rfc}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        {/* CONTACTO */}
        <div>
          <label className="block text-sm font-bold text-[#3F1907] mb-1">
            Dirección
          </label>
          <input
            name="address"
            value={settings.address}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-bold text-[#3F1907] mb-1">
            Teléfono
          </label>
          <input
            name="phone"
            value={settings.phone}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        {/* CONFIG VISUAL */}
        <div className="border-t pt-4">
          <h3 className="text-md font-bold text-[#3F1907] mb-2">
            Configuración Visual
          </h3>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="show_order_number"
              checked={settings.show_order_number == 1}
              onChange={handleChange}
            />
            Mostrar número de orden
          </label>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="show_cashier"
              checked={settings.show_cashier == 1}
              onChange={handleChange}
            />
            Mostrar cajero
          </label>

          <label className="flex items-center gap-2">
            <input
              type="checkbox"
              name="show_qr"
              checked={settings.show_qr == 1}
              onChange={handleChange}
            />
            Mostrar QR
          </label>

          {settings.show_qr == 1 && (
            <input
              name="qr_url"
              value={settings.qr_url}
              onChange={handleChange}
              placeholder="URL para QR (facturación o feedback)"
              className="w-full border px-3 py-2 rounded mt-2"
            />
          )}
        </div>

        {/* OTROS */}
        <div>
          <label className="block text-sm font-bold text-[#3F1907] mb-1">
            Mensaje final
          </label>
          <input
            name="footer_message"
            value={settings.footer_message}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          />
        </div>

        <div>
          <label className="block text-sm font-bold text-[#3F1907] mb-1">
            Tamaño Ticket
          </label>
          <select
            name="ticket_width"
            value={settings.ticket_width}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded"
          >
            <option value="80">80mm</option>
            <option value="58">58mm</option>
          </select>
        </div>

        {/* BOTÓN */}
        <button
          onClick={handleSave}
          className="bg-[#58735A] text-white px-4 py-2 rounded w-full hover:opacity-90"
        >
          Guardar Configuración
        </button>

      </div>
    </div>
  );
};

export default TicketSettingsPage;